import * as S from './PastChatsHistory.styles';
import React, { memo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Table, HistoryDetails } from 'components';
import { formatTableData, tableHead } from './PastChatsHistory.config';
import { getPastChatHistory } from 'redux_toolkit/reducers/partner/visitors/visitorsSlice';


export const PastChatsHistory = memo(({
  visitor,
  pastChats
}) => {
  const dispatch = useDispatch()
  const { partnerId } = useSelector(({ userPartner })=> userPartner.userData);
  const { pastChatsHistory } = useSelector(({ visitors })=> visitors);
  const [selectedChatId, setSelectedChatId] = useState();
  const [selectedChat, setSelectedChat] = useState();

  useEffect(() => {
    const thereIsChat = pastChatsHistory.get(selectedChatId);
    if (selectedChatId && thereIsChat) setSelectedChat(thereIsChat);
  }, [pastChatsHistory, selectedChatId])

  return (
    <S.PastChatsHistory>
      {pastChats?.length && (
        <Table
          tableHead={tableHead}
          tableData={formatTableData(pastChats)}
          pastChatCardStyles={true}
          onRowClick={(chat) => {
            setSelectedChatId(chat._id);
            const thereIsChat = pastChatsHistory.get(chat._id);
            if (!thereIsChat) dispatch(getPastChatHistory({partnerId, chatId: chat._id}));
          }}
        />
      )}

      {selectedChat && selectedChatId && 
        <HistoryDetails
          partnerId={partnerId}
          item={selectedChat}
          showActions={false}
          visitorPartner={visitor}
          onClose={() => {
            setSelectedChatId(null);
          }}
        />
      }
    </S.PastChatsHistory>
  )
}, (prevProps, nextProps)=> {
  return (
    prevProps.visitor === nextProps.visitor &&
    prevProps.pastChats === nextProps.pastChats
  );
})